import { render, staticRenderFns } from "./DashboardCRM.vue?vue&type=template&id=758c6af4&scoped=true"
import script from "./DashboardCRM.vue?vue&type=script&lang=js"
export * from "./DashboardCRM.vue?vue&type=script&lang=js"
import style0 from "./DashboardCRM.vue?vue&type=style&index=0&id=758c6af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758c6af4",
  null
  
)

export default component.exports